import PropTypes from 'prop-types';
import styles from './newCustomInput.module.css';

const NewCustomInput = ({ label, name, type, value, onChange, placeholder, required, error }) => {
  return (
    <div className="mb-1">
      <div className={styles.input__wrapper}>
        <input
          type={type}
          id={name} // Added to link with label's htmlFor
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          title={label}
          required={required}
          className={`${styles.input__field} pt-4 pb-2 bg-white ${error ? 'border-red-500 focus:ring-red-500' : ''}`}
        />
        <label htmlFor={name} className={styles.input__label}>
          {placeholder}
        </label>
      </div>
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};

NewCustomInput.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  required: PropTypes.bool,
};

NewCustomInput.defaultProps = {
  type: 'text',
  value: '',
  placeholder: '',
  error: null,
  required: false,
};

export default NewCustomInput;